import type { Maybe } from '@adornis/base/utilTypes.js';
import { Int } from '@adornis/baseql/baseqlTypes.js';
import { Entity, Field } from '@adornis/baseql/decorators.js';
import { MongoEntity } from '@adornis/baseql/entities/mongoEntity.js';
import type { EntityData } from '@adornis/baseql/entities/types.js';
import { getRawCollection } from '@adornis/baseql/server/collections.js';
import { validate } from '@adornis/validation/decorators.js';
import { nonOptional } from '@adornis/validation/functions/nonOptional.js';
import { CampusLevumiLevel } from './CampusLevumiLevel.js';

/**
 * @entity CampusLevumiItemNumberDictation
 */
@Entity()
export class CampusLevumiItemNumberDictation extends MongoEntity {
  public static override _class = 'CampusLevumiItemNumberDictation';
  public static override _collectionName = 'campus-levumi-number-dictation-items';

  /**
   * The category describes the inner difficulty of the item. The category follows the structure after Zuber et al. 2009
   * It is NOT enforced by an algorithm the editor is fully responsible to categorize the item correctly
   * TODO (good first issue) maybe validate the category and/or do an auto selection in the frontend. In this case just give a suggestion. An item can fullfil multiple categories
   */
  @Field(type => Int, {
    default: v => v ?? 1,
  })
  public category!: number;

  @validate(nonOptional())
  @Field(type => Int)
  public item: Maybe<number>;

  @validate(nonOptional())
  @Field(type => String)
  public levelID!: string;

  @Field(type => CampusLevumiLevel, {
    resolve: function (this: CampusLevumiItemNumberDictation) {
      return async () => {
        const col = await getRawCollection<EntityData<CampusLevumiLevel>>(CampusLevumiLevel._collectionName);
        const res = (await col.findOne({ _id: this.levelID })) as Maybe<CampusLevumiLevel>;
        return res;
      };
    },
  })
  public level!: CampusLevumiLevel;
}
